var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"text-align":"center"}},[_c('h3',[_vm._v(" Authorization successful ")]),_c('p',[_vm._v(" Please close this window ")])])
}]

export { render, staticRenderFns }